export default class HyperlinkText extends createjs.Text {
    constructor(text, font, color, style, href) {
        super(text, font, color);

        this._defaultColor = color;
        this._style = style;
        this._href = href;

        this._handleClickBound = this._handleClick.bind(this);
        this._handleRollOverBound = this._handleRollOver.bind(this);
        this._handleRollOutBound = this._handleRollOut.bind(this);

        this.initialize();
    }

    initialize() {
        this._addEventListeners();
        this.updateHitArea();
    }

    destroy() {
        this._removeEventListeners();
    }

    updateHitArea() {
        const padding = 8;
        const rectGraphic = new createjs.Graphics()
            .beginFill("#f00")
            .drawRect(-padding, -padding, this.getMeasuredWidth() + padding, this.getMeasuredHeight() + padding);

        const rect = new createjs.Shape(rectGraphic);
        this.hitArea = rect;
    };

    setColor(color) {
        this.color = color;

        if (this.underline) {
            this.underline.redraw();
        }
    }

    _addEventListeners() {
        this.addEventListener('click', this._handleClickBound);
        this.addEventListener('rollover', this._handleRollOverBound);
        this.addEventListener('rollout', this._handleRollOutBound);
    }

    _removeEventListeners() {
        this.removeEventListener('click', this._handleClickBound);
        this.removeEventListener('rollover', this._handleRollOverBound);
        this.removeEventListener('rollout', this._handleRollOutBound);
    }

    _handleClick() {
        if (this._href) {
            window.open(this._href, '_blank');
        }
    }

    _handleRollOver() {
        this.cursor = "pointer";
        if (this._style && this._style.hover) {
            this.setColor(this._style.hover.color);
        }
    }

    _handleRollOut() {
        this.setColor(this._defaultColor);
    }
}